import api from '@utils/api';
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import checkoutSlice from './checkout.slice';
import { CheckoutActionTypes } from './common.types';
function* handleFetchPickup() {
    const storesData = yield call(api.getStoresForPickup);
    yield put(checkoutSlice.actions.updatePickupData(storesData));
}
function* handleFetchCheckoutData(action) {
    const checkoutData = yield call(() => { var _a; return api.getCheckoutData((_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.removeGCs); });
    yield put(checkoutSlice.actions.updateOrder(checkoutData.order));
    yield put(checkoutSlice.actions.updateCheckoutData(checkoutData));
}
function* handleFetchPayByLinkCheckoutData(action) {
    const checkoutData = yield call(() => { var _a; return api.getPBLCheckoutData(action.payload.orderID, action.payload.orderToken, (_a = action.payload) === null || _a === void 0 ? void 0 : _a.removeGCs); });
    yield put(checkoutSlice.actions.updateOrder(checkoutData.order));
    yield put(checkoutSlice.actions.updatePBLCheckoutData(checkoutData));
}
function* handleFetchAddresses() {
    const callresult = yield call(api.getAddressBook);
    const addresses = callresult.addresses;
    const countryCode = yield select((state) => state.checkout.countryCode);
    const countryAddresses = addresses.filter((address) => { var _a; return ((_a = address.countryCode) === null || _a === void 0 ? void 0 : _a.value) === countryCode; });
    yield put(checkoutSlice.actions.updateAddresses(countryAddresses));
}
function* handleFetchPaymentMethods(action) {
    const adyenPaymentMethodsResponse = yield call(api.getPaymentMethods, action === null || action === void 0 ? void 0 : action.payload);
    yield put(checkoutSlice.actions.updatePaymentMethods(adyenPaymentMethodsResponse));
}
function* handleUpdateOrder(action) {
    yield put(checkoutSlice.actions.updateOrder(action.payload));
}
function* handleUpdateShippingMethod(action) {
    yield put(checkoutSlice.actions.updateShippingMethods(action.payload));
}
function* handleUpdateCustomer(action) {
    yield put(checkoutSlice.actions.updateCustomer(action.payload));
}
function* handleUpdateEmail(action) {
    yield put(checkoutSlice.actions.updateEmail(action.payload));
    const saveMailResponse = yield call(api.checkoutSaveMail, action.payload);
    if (saveMailResponse.success) {
        yield put(checkoutSlice.actions.updateOrder(saveMailResponse.order));
    }
}
function* handleUpdateLoading(action) {
    yield put(checkoutSlice.actions.updateLoading(action.payload));
}
function* handleUpdateIsFetching(action) {
    yield put(checkoutSlice.actions.updateIsFetching(action.payload));
}
function* handleShippingAddress(action) {
    yield put(checkoutSlice.actions.updateShippingAddress(action.payload));
}
function* handleAddPromoCode(action) {
    yield put(checkoutSlice.actions.resetPromoCodeError());
    const data = yield call(api.addPromoCode, action.payload);
    if ((data === null || data === void 0 ? void 0 : data.error) === true) {
        yield put(checkoutSlice.actions.setPromoCodeError(data.errorMessage));
        return;
    }
    yield handleFetchCheckoutData();
}
function* handlePromoCodeRemove(action) {
    yield put(checkoutSlice.actions.resetPromoCodeError());
    const data = yield call(api.promocodeRemove, action.payload);
    if ((data === null || data === void 0 ? void 0 : data.error) === true) {
        yield put(checkoutSlice.actions.setPromoCodeError(data.errorMessage));
        return;
    }
    yield handleFetchCheckoutData();
}
function* handleGiftCardsApplied(action) {
    yield put(checkoutSlice.actions.updateGiftCardsApplied(action.payload));
}
function* watchFetchRequest() {
    yield takeEvery(CheckoutActionTypes.FETCH_CHECKOUTDATA, handleFetchCheckoutData);
    yield takeEvery(CheckoutActionTypes.FETCH_PBLCHECKOUTDATA, handleFetchPayByLinkCheckoutData);
    yield takeEvery(CheckoutActionTypes.FETCH_ADDRESSES, handleFetchAddresses);
    yield takeEvery(CheckoutActionTypes.FETCH_PAYMENTMETHODS, handleFetchPaymentMethods);
    yield takeEvery(CheckoutActionTypes.UPDATE_ORDER, handleUpdateOrder);
    yield takeEvery(CheckoutActionTypes.UPDATE_EMAIL, handleUpdateEmail);
    yield takeEvery(CheckoutActionTypes.FETCH_PICKUP, handleFetchPickup);
    yield takeEvery(CheckoutActionTypes.UPDATE_SHIPPINGMETHODS, handleUpdateShippingMethod);
    yield takeEvery(CheckoutActionTypes.UPDATE_CUSTOMER, handleUpdateCustomer);
    yield takeEvery(CheckoutActionTypes.UPDATE_LOADING, handleUpdateLoading);
    yield takeEvery(CheckoutActionTypes.UPDATE_IS_FETCHING_DATA, handleUpdateIsFetching);
    yield takeEvery(CheckoutActionTypes.UPDATE_SHIPPINGADDRESS, handleShippingAddress);
    yield takeEvery(CheckoutActionTypes.ADD_PROMO_CODE, handleAddPromoCode);
    yield takeEvery(CheckoutActionTypes.REMOVE_PROMO_CODE, handlePromoCodeRemove);
    yield takeEvery(CheckoutActionTypes.UPDATE_GIFTCARDS_APPLIED, handleGiftCardsApplied);
}
export default function* bagSaga() {
    yield all([fork(watchFetchRequest)]);
}
